import { render, staticRenderFns } from "./addrItem.vue?vue&type=template&id=7f8728ac&scoped=true"
import script from "./addrItem.vue?vue&type=script&lang=js"
export * from "./addrItem.vue?vue&type=script&lang=js"
import style0 from "./addrItem.vue?vue&type=style&index=0&id=7f8728ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8728ac",
  null
  
)

export default component.exports